<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    title="团长管理"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
  >
    <div class="content">
      <!-- 功能条 -->
      <div class="tool-view">
        <!-- 弹簧 -->
        <div style="flex: 1;"></div>
        <!-- 操作 -->
        <a-button type="primary" @click="touchAdd"><PlusOutlined />添加团长</a-button>
      </div>
      <!-- 列表 -->
      <a-table
        class="table-view"
        :data-source="dataSource"
        :columns="columns"
        :row-key="record => record.id"
        :pagination="pagination"
        :loading="isLoading"
        @change="handleTableChange"
      >
        <!-- 自定义行内容 -->
        <template #bodyCell="{ column, record }">
          <!-- 类型 -->
          <template v-if="column.key === 'type'">
            {{ (ClientTypes.find(item => item.value === record[column.key]) || {}).text || '-' }}
          </template>
          <!-- 操作 -->
          <template v-if="column.key === 'operation'">
            <a class="operation-item" @click="touchEdit(record)">编辑</a>
            <a class="operation-item" @click="touchLink(record)">数据链接</a>
          </template>
        </template>
      </a-table>
    </div>
    <!-- 新增、编辑弹窗 -->
    <Add ref="RefAdd" @success="getList" />
  </a-drawer>
</template>

<script setup>
import { message } from 'ant-design-vue'
import { ref, reactive, defineExpose } from 'vue'
import Pub from '@/utils/public'
import Add from './AddClient.vue'
import { ClientTypes } from '@/utils/constantList'
import { leaderList } from '@/api/agency'

// 回调
const emit = defineEmits('success')
// 新增
let RefAdd = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 详情
const detail = ref({})
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '团长ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '团长名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '关联达人数',
    dataIndex: 'daren_count',
    key: 'daren_count'
  },
  {
    title: '入库日期',
    dataIndex: 'date',
    key: 'date'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 打开抽屉
function showDrawer (record) {
  detail.value = record
  visible.value = true
  // 重置到第一页，避免沿用之前分页
  pagination.current = 1
  // 获取列表
  getList()
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    visible.value = false
    pagination.current = 1
    pagination.total = 0
    dataSource.value = []
  }
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 获取列表
function getList () {
  isLoading.value = true
  const params = {
    provider_id: detail.value && detail.value.id != null ? String(detail.value.id) : undefined,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  console.log('[Client Drawer] leaderList params:', params)
  leaderList(params).then(res => {
    isLoading.value = false
    console.log('[Client Drawer] leaderList response:', res)
    const { code, data, msg } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  })
}

// 添加服务商
function touchAdd () {
  RefAdd.value.showDrawer({}, detail.value.id)
}

// 编辑服务商
function touchEdit (record) {
  RefAdd.value.showDrawer(record, detail.value.id)
}

// 数据链接
function touchLink(record) {
  Pub.COPY(`【${record.name}】团长链接：${Pub.DOMAIN_NAME()}/summary-data?type=2&id=${record.leader_number}`)
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.tool-view {
  padding-bottom: 20px;
  display: flex;
  align-items: center;
}
.content-item {
  line-height: 40px;
  .title {
    font-size: 14px;
  }
  .desc {
    font-size: 14px;
    color: #5A5A5A;
  }
}
</style>